module.exports = __webpack_public_path__ + "img/card-bg2.e66ea4b1.png";